/**
 * GrowthRIQ wordmark — pure text/CSS, no image.
 *
 * Inspired by the iter25 brand reference: "GROWTH" in primary color, "RIQ"
 * accented in teal #3CD9B8. Bold uppercase sans-serif with tight tracking.
 *
 * Props:
 *   variant: "dark"  → use on dark/navy backgrounds (GROWTH=white,  RIQ=teal)
 *            "light" → use on light/white backgrounds (GROWTH=navy,  RIQ=teal)
 *   size:    "sm" | "md" (default) | "lg" | "xl"
 *   accentDot: boolean — append a small teal square accent after the wordmark
 *   className: string  — additional Tailwind utilities (e.g., positioning)
 */
const SIZE_MAP = {
  sm: 'text-base',           // ~16px
  md: 'text-xl',             // ~20px (matches old h-8 PNG)
  lg: 'text-3xl',            // ~30px
  xl: 'text-4xl md:text-5xl' // hero
};

export default function Logo({
  variant = 'light',
  size = 'md',
  accentDot = false,
  className = '',
  ...rest
}) {
  const isDark = variant === 'dark';
  const baseColor = isDark ? 'text-white' : 'text-[#0F1B36]';
  const accentColor = 'text-[#3CD9B8]';
  return (
    <span
      className={`inline-flex items-baseline font-sans font-extrabold uppercase tracking-[-0.03em] leading-none select-none ${SIZE_MAP[size] || SIZE_MAP.md} ${className}`}
      aria-label="GrowthRIQ"
      data-testid="brand-logo"
      {...rest}
    >
      <span className={baseColor}>GROWTH</span>
      <span className={accentColor}>RIQ</span>
      {accentDot && (
        <span
          aria-hidden="true"
          className={`ml-0.5 inline-block w-1.5 h-1.5 ${isDark ? 'bg-[#3CD9B8]' : 'bg-[#3CD9B8]'} self-end mb-1`}
        />
      )}
    </span>
  );
}
